import { Status } from '../models/status.enum';

export const AppConstant = {
  CHANGE_HISTORY_TITLE: 'History',
  CHANGE_HISTORY_TEXT: 'History',
  SHARED_AUTHORITY_TEXT_CAPS: 'SHARED AUTHORITY',
  RELEASE_AUTHORITY_TEXT: 'Release Authority',
  RELEASE_SHARED_AUTHORITY_TEXT: 'Release Shared Authority',
  TRANSFER_TO_PAPER_TEXT: 'Transfer To Paper',
  COMMENTS_TEXT: 'Comments',
  MODIFY_AUTHORITY_TEXT: 'Modify Authority',
  SHARE_AUTHORITY_TEXT: 'Share Authority',
  POLL_TIME: 30000,
  SHARED_STATUS_PENDING: 'Pending',
  SHARED_STATUS_REVIEW_REQUEST: 'Review Request',
  SHARED_STATUS_UNSHARE: 'Unshare',
  ACCEDPTED_MODIFICATIONS: 'Accepted Modifications',
  ACCEPTED: 'Accepted',
  AUTHORITY_SHARED: 'AUTHORITY_SHARED',
  CONFIRMATION_ACCEPT: 'confirmationAccept',
  CLOSE_CONFIRMATION: 'closeConfirmation',
  CONFIRMATION_TEXT: 'Confirmation',
  USER_CONFIRMATION: 'Are you sure you want to Cancel?',
  ACCEPT_LABEL: 'No, Share Proposed Modification',
  REJECT_LABEL: 'Yes, Cancel Modification',
  CONFIRMATION_ACTION_RR: 'RR',
  ERROR_MESSAGE: 'There seems to be an error. Please contact system administator',
  DISPATCHER_TEXT: 'Dispatcher',
  EXPIRED_NOTIFICATION_TEXT: 'No Response Required',
  AUTHORITY_ACCEPTED_MODIFICATION: 'AUTHORITY_ACCEPTED_MODIFICATION',
  AUTHORITY_ACCEPTED_MODIFICATION_DISPATCHER: 'AUTHORITY_ACCEPTED_MODIFICATION_DISPATCHER',
  REJECTED_MODIFICATION: 'Rejected Modification',
  AUTHORITY_REJECTED_MODIFICATION: 'REJECTED_MODIFICATION',
  AUTHORITY_MODIFIED: 'AUTHORITY_MODIFIED',
  AUTHORITY_RELEASED: 'AUTHORITY_RELEASED',
  AUTHORITY_SHARE_REQUEST: 'AUTHORITY_SHARE_REQUEST',
  AUTHORITY_MODIFIED_SUBMIT: 'AUTHORITY_MODIFIED_SUBMIT',
  regExp: /\(([^)]+)\)/,
  COLOR_GREEN: 'green',
  COLOR_BLUE: 'blue',
  COLOR_RED: 'red',
  COLOR_ORANGE: 'orange',
  EMPLOYEE: 'Employee',
  confirmBtnTitle_YES: 'Yes',
  REJECT_CONFIRMATION_MESSAGE: 'Are you sure, you want to reject?',
  INTIAL_POINT_OF_OCCUPANCY: 'Initial Point of Occupancy',
  COLON_AND_SPACE: ': ',
  SPACE_STRING: ' ',
  EMPTY_STRING: '',
  SHARED_BY: 'Shared by',
  MODIFCATION_REQUEST_SENT_TO_DISPATCHER: 'Modification request sent to Dispatcher',
  CONFIRM_TYPE_A: 'A',
  AWAITING_RESPONSE_MODIFICATION_STATUS: [
    Status.AUTHORITY_USER_REJECTED,
    Status.AUTHORITY_USER_APPROVED,
    Status.RELEASE_USER_REJECTED,
    Status.RELEASE_USER_APPROVED,
    Status.AUTHORITY_REQUESTED,
    Status.AUTHORITY_SENT,
    Status.AUTHORITY_PENDING
  ],
  AWAITING_RESPONSE_RELEASED_AUTHORITY_STATUS: [Status.RELEASE_REQUESTED, Status.RELEASE_SENT, Status.RELEASE_PENDING],
  ELIPSIS_MENU_ARRAY: [
    {
      label: 'Release Authority',
      disabled: false,
      visible: true,
      styleClass: 'conditional-menu-item'
    },
    {
      label: 'Transfer To Paper',
      disabled: false,
      visible: true,
      styleClass: 'conditional-menu-item'
    },
    {
      label: 'Comments',
      disabled: false,
      visible: true,
      styleClass: 'conditional-menu-item'
    },
    {
      label: 'Modify Authority',
      disabled: false,
      visible: true
    },
    {
      label: 'History',
      disabled: false,
      visible: true
    }
  ],
  AUTHORITY_MODIFICATION_PROGRESS_STATUS: [
    Status.CHANGE_PROPOSED,
    Status.CHANGE_PROPOSED_ACCEPTED,
    Status.CHANGE_SENT,
    Status.CHANGE_PENDING,
    Status.CHANGE_DISPATCHER_APPROVED,
    Status.CHANGE_PROPOSED_PARTIALLY_ACCEPTED,
    Status.CHANGE_USER_REJECTED,
    Status.CHANGE_DISPATCHER_REJECTED
  ],
  RELEASE_AUTHORITY_MODIFY_IN_PROGRESS_STATUS: [
    Status.CHANGE_REQUEST,
    Status.CHANGE_SENT,
    Status.CHANGE_PENDING,
    Status.CHANGE_DISPATCHER_APPROVED,
    Status.CHANGE_USER_REJECTED,
    Status.CHANGE_USER_APPROVED
  ],
  ELIPSIS_MENU_ADMIN: [
    {
      label: 'Proxy User',
      visible: true
    },
    {
      label: 'Manage Outage',
      visible: true
    }
  ],

  ELIPSIS_MENU_DISABLE_INDEX: [0],
  HASH_LABEL: '#',
  CHANGE_HISTORY: 'History',
  SA_POP_UP_COLUMN_NAMES: [
    {
      name: 'Status',
      style: 'table-column column-line-sa'
    },
    {
      name: 'Line',
      style: 'table-column column-line-sa'
    },
    {
      name: 'Operate On',
      style: 'table-column column-operate-on-sa'
    },
    {
      name: 'Operating From',
      style: 'table-column column-from-sa'
    },
    {
      name: 'Operating To',
      style: 'table-column column-to-sa'
    },
    {
      name: 'Direction',
      style: 'table-column column-direction-sa'
    },
    {
      name: 'Time/Date',
      style: 'table-column column-dated-sa'
    }
  ],
  AUTHORITY_HISTORY_COLUMN_NAMES: [
    {
      name: 'Line',
      style: 'table-column column-ec1number'
    },
    {
      name: 'Operate On',
      style: 'table-column column-operate-on-au'
    },
    {
      name: 'Operating From',
      style: 'table-column column-from-au'
    },
    {
      name: 'Operating To',
      style: 'table-column column-to-au'
    },
    {
      name: 'Direction',
      style: 'table-column column-direction-au'
    },
    {
      name: 'Time/Date',
      style: 'table-column column-dated'
    }
  ],

  ERROR_IN_CHANGE_REQUEST_API: 'Error in change request Api.',
  ERROR_GET_CHANGE_REQUEST_FAILED: 'get change request failed.',
  ERROR_IN_POST_NOTIFICATION_API: 'Error in post Notification Api.',
  AUTH_SHARED_ACCEPT_LABEL: 'Accept Shared Authority',
  AUTH_SHARED_REJECT_LABEL: 'Reject Not required',
  AUTH_RELEASE_ACCEPT_LABEL: 'Release Shared Authority',
  AUTH_RELEASE_REJECT_LABEL: 'Reject Release Request',
  AUTH_SHARED_REQUEST_ACCEPT_LABEL: 'Accept Shared Request',
  AUTH_SHARED_REQUEST_REJECT_LABEL: 'Reject Sharing Request',
  REQUESTED_BY_TEXT: 'Requested by',
  AUTH_MODIFIED_ACCEPT_LABEL: 'Accept Modification',
  AUTH_MODIFIED_REJECT_LABEL: 'Reject Modification',
  AUTH_SUBMIT_ACCEPT_LABEL: 'Submit Modification',
  AUTH_SUBMIT_REJECT_LABEL: 'Cancel Modification',
  CANCEL_MODIFICATIOB_CONFIRMATION_TEXT: 'Are you sure, you want to Cancel Modification?',
  RELEASE_LATER_CONFIRMATION: 'Are you sure, you want to  Release Later?'
};
